<div class="top-panel">
    <div class="toolbar">
        <div class="left-content">
            <div class="product-logo-container">
                <img [ngClass]="'logo__' + envName"
                     ngSrc="assets/PlowOpsLogo_Snowflake.svg"
                     [alt]="dashboardVersion"
                     [matTooltip]="'PlowOps: ' + dashboardVersion"
                     [routerLink]="['/' + RootRoute.MAIN]"
                     class="logo"
                     height="24" width="24" />
                <h1>Account Setup</h1>
            </div>
        </div>
        <div class="centered-content">
        </div>
        <div class="right-content mr-24">
            <div class="flex-row align-items-center whitespace-no-wrap">
                <h2 class="mb-0">
                    @if (!configurationResource.isLoading()) {
                        {{configurationResource.value().customerName}}
                    }
                </h2>
                <button
                  mat-icon-button
                  [routerLink]="['/']"
                            color="heavy"
                            aria-label="close"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="top-panel-shadow" [ngClass]="{ 'has-shadow': isMainContentScrolled}"></div>
<div class="content-container" role="main">
    <div class="left-panel">
        <div role="navigation" class="settings-menu">
            <div class="left-menu" id="menu" role="menu">
              @for (item of settingsSections; track $index) {
                <a class="menu-item" matRipple
                   [routerLink]="item.id" routerLinkActive="selected">
                  <mat-icon>{{item.icon}}</mat-icon>
                  {{item.name}}
                </a>
              }
            </div>
            @if (configurationResource.isLoading() || hasAdminRoleResource.isLoading()) {
              <mat-progress-bar
                mode="indeterminate"></mat-progress-bar>
            }
        </div>
    </div>
    <div class="main-panel">
        <div class="main-content">
            <div #mainContentTopMark><!-- An invisible mark used to detect the scroll position --></div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
